import { render, staticRenderFns } from "./top-swipe-item.vue?vue&type=template&id=a076fa56&scoped=true&"
import script from "./top-swipe-item.vue?vue&type=script&lang=js&"
export * from "./top-swipe-item.vue?vue&type=script&lang=js&"
import style0 from "./top-swipe-item.vue?vue&type=style&index=0&id=a076fa56&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a076fa56",
  null
  
)

export default component.exports